import {cancelOrder} from "@/services/approval";

export default {
  actions: {
    async cancelOrderById({dispatch}, {id, cancellation_reason}) {
      await cancelOrder(id, cancellation_reason);
      // return dispatch('reloadOrderDetails');
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/admin.js